import { ReactNode } from 'react';
import { Box, Flex } from '@mantine/core';
import { TextLoader } from 'components/shared';

type Props = {
  displayLoader?: boolean;
  children: ReactNode;
};

export const Layout = ({ displayLoader = false, children }: Props) => (
  <Box
    sx={theme => ({
      margin: -theme.other.spacing(2),
      height: `calc(100% + ${theme.other.spacing(4)}px)`,
      background: '#F6F8FA',
      display: 'flex',
      flexDirection: 'column',
    })}
  >
    {!displayLoader ? (
      children
    ) : (
      <Flex justify="center" align="center" h="100%">
        <TextLoader>&nbsp;</TextLoader>
      </Flex>
    )}
  </Box>
);
